<!-- src/components/ParkingTypes.vue -->
<template>
  <div class="parking-types">
    <h2 class='section-title'>停車場形式</h2>
    <div class="types-grid">
      <div class="type-item" v-for="(item, index) in parkingTypes" :key="index">
        <img :src="item.image" :alt="item.name" loading="lazy">
        <p>{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
// 使用 require 引用本地图片
export default {
  name: 'ParkingTypes',
  data() {
    return {
      parkingTypes: [
        {
          name: '露天平面',
          image: require('@/assets/parking-types/露天平面_1.jpg') // 使用 require
        },
        {
          name: '車道平面',
          image: require('@/assets/parking-types/車道平面_1.jpg')
        },
        {
          name: '立體停車塔',
          image: require('@/assets/parking-types/立體停車場_1.jpg')
        },
        {
          name: '大樓地下機械倉儲式',
          image: require('@/assets/parking-types/大樓地下機械倉儲式_1.jpg')
        }
      ]
    }
  }
}
</script>

<style scoped>
.parking-types {
  width: 1416px;
  margin: 0 auto;

  margin-bottom: 120px;
}


.types-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 默认4列布局 */
  gap: 24px;
  margin: 0 auto;
}

.type-item {
  text-align: center;
  width:336px;
}

.type-item img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 2rem;
}

.type-item p {
  /* //styleName: xl/bold; */
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  margin-top: 20px;
  margin-bottom: 0px;

  color: var(--green03);
}


@media (max-width: 560px) {

  .parking-types {
    width: 343px; /* 调整宽度 */
  }


  .types-grid {
    grid-template-columns: repeat(2, 1fr); /* 560px以下调整为2列 */
    gap: 12px;                              /* 可根据需要调整间距 */
    max-width: 343px;                         /* 调整最大宽度以适应小屏幕 */
  }

  .type-item {
  text-align: center;
  width:166px;
  }

  .type-item img {
    width:166px;
    height: 208px; /* 调整图片高度以适应卡片 */
    border-radius: 20px; /* 调整圆角 */
  }

  .type-item p {
    /* //styleName: md/bold; */
font-family: Inter;
font-size: 16px;
font-weight: 700;
line-height: 24px;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;

  margin-top: 10px; /* 调整上边距 */
  }


}
</style>
